import Text from "@mui/material/Typography";
import { SnackbarMessage, useSnackbar, VariantType } from "notistack";
import { createElement } from "react";

export function useNotification() {
    const { enqueueSnackbar } = useSnackbar();

    function enqueue(variant: VariantType, message: SnackbarMessage, duration?: number) {
        const text = typeof message === "string" ? createElement(Text, {
            children: message.truncate(200)
        }) : message;
        enqueueSnackbar(text, {
            variant,
            autoHideDuration: duration,
            persist: variant === "error",
        });
    }
    return {
        error(message: SnackbarMessage) {
            enqueue("error", message);
        },
        info(message: SnackbarMessage) {
            enqueue("info", message);
        },
        log(message: SnackbarMessage) {
            enqueue("default", message);
        },
        success(message: SnackbarMessage) {
            enqueue("success", message);
        },
        warn(message: SnackbarMessage) {
            enqueue("warning", message);
        }
    }
}

type NotificationData = {
    variant: VariantType;
    message: SnackbarMessage;
}
class NotificationController {
    message?: NotificationData;
    dispatch(variant: VariantType, message: SnackbarMessage) {
        this.message = { variant, message };
        window.dispatchEvent(new CustomEvent("fuzion.notification.dispatch", {
            detail: { variant, message }
        }));
    }
}
const controller = new NotificationController();
export const NotificationHelper = Object.freeze({
    notify(variant: VariantType, message: SnackbarMessage) {
        controller.dispatch(variant, message);
    },
    subscribe(listener: () => void) {
        window.addEventListener("fuzion.notification.dispatch", listener);
        return () => {
            window.removeEventListener("fuzion.notification.dispatch", listener);
        }
    },
    getSnapshot() {
        return controller.message;
    }
});